<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <Caption label="Admin Server" />
        <ul>
          <li>
            <SectionTechItem 
              :image="'tech_icon_aws.png'"
              :record ="{
                text1:'AWS Cloud',
                text2:'Backend 관리자 서버도 AWS cloud에 배포되어, 따로  서버 관리를 해야할 필요가 없이, AWS가 관리해줍니다',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_nodejs.png'"
              :record ="{
                text1:'Node JS',
                text2:'AWS Cloud lambda와 잘 어울리는 개발 언어 입니다',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_ra.png'"
              :record ="{
                text1:'React-Admin',
                text2:'운영 관리를 위한 대부분의 기능이 모여져 있습니다. React 기반이며, 페이징, 검색, CRUD를 안정적으로 제공합니다',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_mongo.png'"
              :record ="{
                text1:'Mongo DB Cloud',
                text2:'강력한 No SQL DB이며, AWS에 포팅되고 각종 모니터링 기능과 버튼 한번 클릭의 Scale Up을 제공합니다',
              }"/>
          </li>
        </ul>

        <div class="desc">
          백앤드 관리자는 성공적인 운영을 위한 도구입니다. <br/>
          
좋은 제품을 출시하는 것 뿐만 아니라 고객 VOC대응,서비스의 돌발 상황에 대한 대처를 잘 해야만 합니다. <br/>
먼데이리스는 React-Admin 을 이용해 손쉽게 운영 툴을 구축합니다<br/>
먼데이리스는 서비스를 직접 키울 생각으로 관리시스템을 만들어 드립니다<br/>
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
import SectionTechItem from "./SectionTechItem.vue";
export default {
  components: {
    Caption,
    SectionTechItem,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 100px 20px 100px 20px;
}

.title_box {
  width: 272px;
}
ul {
  margin-bottom: 80px;
  width: 100%;
  justify-content: space-between;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

ul li {
  margin-top: 50px;
  display: inline-block;
}

.desc {
  font-weight: 300;
  font-size: 24px;
  color: #000000;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 100px 20px 100px 20px;
  }

  .title_box {
    width: 272px;
  }
  ul {
    margin-bottom: 80px;
    width: 100%;
    list-style-type: none;
    display: block;
    text-align: center;
  }

  ul li {
    margin-top: 50px;
    width: fit-content;
    display: block;
    text-align: center;
  }
}
</style>
  